import React, { lazy } from "react";
import { prefetchCmsPage } from "../appShell/appShellContent/appContentShellCache";
import { API_ENDPOINTS } from "../../../../context-module/context-configuration/auth-provider/apiGroup/apiProvider";

// single source of truth imports
const importSalesContact = () =>
    import("../../../../page-module/page-services/sales-contact/ts/salesContact");
const importBusinessContact = () =>
    import("../../../../page-module/page-services/bussiness-contact/ts/businessContact");
const importContact = () =>
    import("../../../../page-module/page-services/contact/ts/contact");
const importCareer = () =>
    import("../../../../page-module/page-services/career/ts/career");
const importCompany = () =>
    import("../../../../page-module/page-services/company/ts/company");

// lazy pages
export const SaleContactLazy = lazy(importSalesContact);
export const BusinessContactLazy = lazy(importBusinessContact);
export const ContactLazy = lazy(importContact);
export const CareerLazy = lazy(importCareer)
export const CompanyLazy = lazy(importCompany)

// preload routes + CMS data
export function preloadStartupRoutesAndData() {
    // preload chunks
    void importSalesContact();
    void importBusinessContact();
    void importContact();
    void importCareer()
    void importCompany()

    // preload CMS data
    void prefetchCmsPage(API_ENDPOINTS.ROUTE_URL.SALE_CONTACT); //NOSONAR
    void prefetchCmsPage(API_ENDPOINTS.ROUTE_URL.BUSINESS_CONTACT); //NOSONAR
    void prefetchCmsPage(API_ENDPOINTS.ROUTE_URL.CONTACT); //NOSONAR
    void prefetchCmsPage(API_ENDPOINTS.ROUTE_URL.CAREER); //NOSONAR
    void prefetchCmsPage(API_ENDPOINTS.ROUTE_URL.COMPANY); //NOSONAR
}